<template>
  <section class="section__main">
         
    <div class="section-box">

      <MainSectionBlob/>
      
      <MainSectionBlobMobile/>

      <MainSectionFooter/>
      <FloatingContact :floatingContactColor="floatingContactColor" :floatingContactLetterColor="floatingContactLetterColor" />
       
    </div>

  </section>
</template>

<script>
// Import small components
import MainSectionTitle from "@/components/small-components/MainSectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import MainSectionBlob from "@/components/small-components/MainSectionBlob";
import MainSectionBlobMobile from "@/components/small-components/MainSectionBlobMobile";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import FloatingContact from "@/components/small-components/FloatingContact";
export default {
  
  name: "Component1",
  data() {
    return {
      floatingContactColor: "#cacaca",
      floatingContactLetterColor: "#000"
    };
  },

  props: [
    'showChild',
    // 'blobMain',
    // 'blobMobile'
  ],
  // Init components
  components: {
    MainSectionTitle: MainSectionTitle,
    MainSectionFooter: MainSectionFooter,
    MainSectionBlob: MainSectionBlob,
    MainSectionBlobMobile,
    FloatingSocials: FloatingSocials,
    FloatingContact: FloatingContact
  },
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/Component1.vue